











import { GeneralDisclaimer } from '@/types';
import Vue from 'vue';
import { mapState } from 'vuex';

export default Vue.extend({
	name: 'DisclaimersAll',
	props: ['isReady'],
	data(): { foundDisclaimers: GeneralDisclaimer[]; refreshId: number }{
		return {
			foundDisclaimers: [],
			refreshId: 0
		};
	},
	methods: {
		// '[&alpha;]' -> '[α]', '[&dagger;]' -> '[†]' etc, so keys stored as
		// entities compare equal to the rendered sup's innerText
		decodeEntities(s: string): string {
			const el = document.createElement('div');
			el.innerHTML = s;
			return (el.textContent || '').trim().toLowerCase();
		},
		findDisclaimer(sup: string): GeneralDisclaimer | undefined {
			const target = this.decodeEntities(sup);
			const d = this.normalisedDisclaimers.find((o: any) => {
				return this.decodeEntities(o.key || '') == target;
			});
			return d;
		},
		normaliseDisclaimer(d: GeneralDisclaimer): GeneralDisclaimer {
			const gd: GeneralDisclaimer = {
				key: d.key || '',
				text: d.text
			}
			if (!gd.key){
				// a keyless disclaimer whose text STARTS with '[..]' carries its key
				// inline (e.g. the finance api's '[&Dagger;] Estimated repayment...')
				const start = gd.text.indexOf('[');
				const end = gd.text.indexOf(']');
				if (start == 0 && end > 0){
					const k = gd.text.substring(start, end+1);
					gd.key = k;
					gd.text = gd.text.replace(k, '').trim()
					console.log('gd', gd);
				}
			}
			if (d.for){
				gd.for = d.for;
			}
			if (d.type){
				gd.type = d.type;
			}
			return gd;
		},
		handleRouteChange(){
			this.foundDisclaimers = [];
			// several watchers can fire in one flush (route + step + useAlpha);
			// their queued callbacks would each append the keyless disclaimers
			// after the shared reset, so only the last scheduled pass may fill
			const id = ++this.refreshId;
			// a macrotask, not nextTick: the Cash/Finance v-tabs-items pane only
			// becomes visible after vuetify's item-group flips isActive in its own
			// $nextTick and re-renders, so a nextTick scan still sees the entering
			// pane as display:none (no client rects) and keeps the old pane's sups
			setTimeout(() => {
				if (id != this.refreshId) return;
				this.normalisedDisclaimers.forEach((d) => {
					if (!d.key && !!d.text){
						this.foundDisclaimers.push(d);
					}
				});
				const keys = Array.from(document.querySelectorAll('sup'));
				keys.forEach((k) => {
					if (k.closest('.tb-disclaimers')){
						console.log('sup found k in disclaimers', k);
						return;
					}
					if (!k.getClientRects().length || k.closest('[class*="-leave-active"]')){
						console.log("sup found k but it's disappearing", k);
						return;
					}
					const sup = (k.innerText || '').trim();
					const d = this.findDisclaimer(sup);
					if (sup && d && !this.foundDisclaimers.find(o => o.key == d.key)){
						this.foundDisclaimers.push(d);
					}
					// else {
					// 	// console.log(`sup not found ${sup}`, d);
					// }
					this.foundDisclaimers = this.foundDisclaimers.toSorted(function(a: GeneralDisclaimer, b: GeneralDisclaimer){
						if (!b.key) return 1;
						return -1;
					});
				});
			});
		}
	},
	computed: {
		...mapState({
			state(): GeneralDisclaimer[] { return (this as any).$store.state },
			disclaimers(): GeneralDisclaimer[] { return (this as any).$store.state.disclaimers },
			finance(): any { return (this as any).$store.state.finance },
			vehicle(): any { return (this as any).$store.state.vehicle },
			valueAdd(): any { return (this as any).$store.state.valueAdd },
			app(): any { return (this as any).$store.state.app },
		}),
		useAlpha(): boolean {
			return (this as any).$store.getters.useAlpha;
		},
		alphaFinance(): any {
			return (this as any).$store.getters.alphaFinance;
		},
		allDisclaimers(): GeneralDisclaimer[] {
			// [α]
			const d = [...JSON.parse(JSON.stringify(this.disclaimers))];
			if (this.useAlpha){
				d.push({
					type: 'alpha',
					for: 'alpha',
					key: '[&alpha;]',
					text: `${((this.alphaFinance as any).disclaimer || '').replace('{vehicle}', `Toyota ${(this.alphaFinance as any).vehicleName || this.vehicle.model}`)}`
				});
			}
			return d;
		},
		// allDisclaimers with inline '[..]' text-prefix keys promoted to real keys;
		// the single list both the keyless push and the sup lookup run against
		normalisedDisclaimers(): GeneralDisclaimer[] {
			return this.allDisclaimers.map((d) => this.normaliseDisclaimer(d));
		},
		enabledDisclaimers(): GeneralDisclaimer[] {
			return this.foundDisclaimers;
		},
		cfTab(): number {
			const s = (this as any).$store;
			return s.getters.viewCurrentQuote ? s.getters.retrievedQuoteView.loanType : this.app.financeType;
		},
	},
	watch: {
		'app.isFinanceLoading'(v){
			if (!v){
				this.handleRouteChange();
			}
		},
		'valueAdd.data'(){
			this.handleRouteChange();
		},
		'vehicle.materialCode'(){
			this.handleRouteChange();
		},
		'finance.isLoading'(v){
			if (!v){
				this.handleRouteChange();
			}
		},
		'disclaimers.length'(){
			this.handleRouteChange();
		},
		'$route.name'(){
			this.handleRouteChange();
		},
		'app.step'(){
			this.handleRouteChange();
		},
		'cfTab'(){
			this.handleRouteChange();
		},
		'useAlpha'(){
			this.handleRouteChange();
		},
		'isReady'(){
			this.handleRouteChange();
		},
	},
	mounted(){
		this.handleRouteChange();
	}
});
